module.exports = __webpack_public_path__ + "img/card-bg2@2x.0896058a.png";